import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CandlestickChart } from "lucide-react";
import api from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const me = await api.createSession(sessionId);
        // clear the fragment so tokens never linger in the URL
        window.history.replaceState(null, "", window.location.pathname);
        setUser(me);
        navigate("/", { replace: true });
      } catch (_) {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 1800);
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen grid place-items-center" style={{ background: "var(--bg)", color: "var(--text)" }} data-testid="auth-callback">
      <div className="flex flex-col items-center gap-4">
        <div className="grid place-items-center rounded-2xl animate-pulse" style={{ width: 56, height: 56, background: "linear-gradient(135deg,#8b5cf6,#6d28d9)" }}>
          <CandlestickChart size={28} color="#fff" strokeWidth={2.4} />
        </div>
        <div className="text-sm" style={{ color: error ? "var(--red)" : "var(--text-muted)" }}>
          {error || "Securing your session…"}
        </div>
      </div>
    </div>
  );
}
